<!-- 成长粒-pc端成长记录详情页 -->
<template>
  <div class="detail flex-page">
    <vx-list
      style="height: 100%"
      :api="api"
      :params="replyCommentParams"
      :enableAutoScrollTop="false"
      @load="onload"
      ref="vxlist"
      class="detail-scroll">
      <div class="detail-scroll-inner" v-if="detail">
        <div class="title">{{detail.commentTitle}}</div>
        <div class="stu-box" v-if="detail.studentList && detail.studentList.length>0">
          <!-- 学员标签区域 -->
          <div class="stu-nav">
            <div 
              class="stu-item"
              :class="{'active':sts.active}"
              v-for="(sts,stsidx) of detail.studentList"
              :key="stsidx"
              @click="initByStudent(stsidx)">
            <img class="is-img" :src="`${sts.album.albumFront}`" v-if="sts.album.albumFront"/>{{sts.studentName}}</div>
          </div>
        </div>
        <!-- 学员图片区域 -->
        <van-swipe class="comment-swiper" :style="`height: ${height}px;`" indicator-color="white" @change="imgChange" ref="swipe" v-if="materialList.length>0">
          <van-swipe-item v-for="(cms,cmsidx) of materialList" :key="cmsidx">
            <van-image class="comment-banner-img bg" fit="cover" alt="" :src="`${cms.originUrl}${cms.materialType == 1?'?x-oss-process=video/snapshot,t_1,f_jpg,w_1000,ar_auto':''}`"></van-image>
            <van-image class="comment-banner-img" fit="scale-down" alt="" :src="`${cms.originUrl}${cms.materialType == 1?'?x-oss-process=video/snapshot,t_1,f_jpg,w_1000,ar_auto':''}`" @click="prewImage(cms)"></van-image>
          </van-swipe-item>
        </van-swipe>
        <!-- 学员点评区域 -->
        <template v-if="detail.contentType == 2">
          <div 
            class="stu-comment"
            v-for="(cls,clsidx) of detail.studentList"
            :key="clsidx">
            <template v-if="cls.active">
              <div class="t1"></div>
              <div class="t2">{{cls.content.list[0].content}}</div>
            </template>
          </div>
        </template>
        <div v-else class="stu-comment">
          <div class="t1"></div>
          <div class="t2" v-if="detail.commentContent && detail.commentContent.list">{{ detail.commentContent.list[0].content}}</div>
        </div>
        <!-- 关联排课区域 -->
        <template v-if="detail.courseArrangeList">
          <div class="publish-box" 
            v-for="(courseArr,courseArrIndex) of detail.courseArrangeList" 
            :key="courseArrIndex">
            <div class="publish-inner3">{{ courseArr.curriculumName }}<span v-if="courseArr.className"> · {{courseArr.className}}</span></div>
            <div class="publish-inner4">{{ courseArr.createTime }}</div>
          </div>
        </template>
        <!-- 点评时间区域 -->
        <div class="publish-time-box" v-if="detail.createTime">发布时间：{{detail.createTime | formatDatetime('yyyy-MM-dd hh:mm') }}</div>
        <!-- 发布人区域 -->
        <div class="publish-box" v-if="detail.teacher">
          <div class="publish-inner1">
            <img class="left xcx-border-surround" :src="`${detail.teacher.profileImgUrl || defaultImg}`" />
            <div class="center">
              <div class="t1 van-multi-ellipsis">{{detail.teacher.name}}<div class="cname">@{{detail.teacher.companyName}}</div></div>
              <div class="t2 van-multi-ellipsis--l2">{{detail.teacher.promotionContent || '这个老师没有留下简介信息。试试直接联系他吧~'}}</div>
            </div>
            <div class="right">
              <img class="img" :src="`https://cdn01.xiaogj.com/uploads/x3/assets/weapp-ai-growth-img/teacher/${detail.teacher.likeStatResult.myselfLike?'icon/0028':'icon/0026'}.png`"/>
              <div class="num" :class="{'red':detail.teacher.likeStatResult.myselfLike}">{{detail.teacher.likeStatResult.likeQuantity ? detail.teacher.likeStatResult.likeQuantity : ''}}</div>
            </div>
          </div>
          <div class="publish-inner2 van-hairline--top">
            <div class="left flex-center">
              <img class="img" src="https://cdn01.xiaogj.com/uploads/x3/assets/weapp-ai-growth-img/teacher/icon/0021.png" mode="aspectFit"/>联系老师
            </div>
            <div class="left flex-center">
              <img class="img" src="https://cdn01.xiaogj.com/uploads/x3/assets/weapp-ai-growth-img/teacher/icon/0020.png" mode="aspectFit"/>让老师联系我
            </div>
          </div>
        </div>
        <!-- 评论区域 -->
        <div class="comment-box">
          <template v-if="replyCommentList && replyCommentList.length > 0">
            <div class="comment-total">共{{commentQuantity}}条评论</div>
            <div class="comment-item mt" v-for="(rc,rcidx) of replyCommentList" :key="rcidx">
              <img class="comment-item-left" :src="`${rc.replyPersonAvatar||defaultImg}`"/>
              <div class="comment-item-right van-hairline--bottom pd">
                <div class="comment-item-right-inner">
                  <div class="right-inner">
                    <div class="c1">{{rc.replyPersonName}}<span class="c1-tag" v-if="(rc.replyPersonType==1&&rc.companyName)||(rc.replyPersonType==2&&rc.studentParentRelation.length>0)">@{{rc.replyPersonType==1?rc.companyName:rc.relationStr}}</span></div>
                    <div class="c2">{{rc.content.list[0].content}}</div>
                    <div class="c3">{{rc.createTime | formatDatetime('MM-dd hh:mm') }}</div>
                    <div class="c4" v-if="rc.teacherLike"><div class="praise-btn">老师赞过</div></div>
                  </div>
                  <div class="right-inner-r">
                    <img class="imgs" :src="`https://cdn01.xiaogj.com/uploads/x3/assets/weapp-ai-growth-img/parent/${rc.myselfLike?'icon/0028':'icon/0026'}.png`"/>
                    <div v-if="rc.likeQuantity" class="num" :class="{'red':rc.myselfLike}">{{rc.likeQuantity}}</div>
                  </div>
                </div>
                <template v-if="rc.replyRecordList && rc.replyRecordList.length>0">
                  <div class="comment-item" style="padding-top: 12px;" v-for="(rrl,rrlidx) of rc.replyRecordList" :key="rrlidx">
                    <img class="comment-item-left" :src="`${rrl.replyPersonAvatar||defaultImg}`"/>
                    <div class="comment-item-right">
                      <div class="comment-item-right-inner">
                        <div class="right-inner">
                          <div class="c1">{{rrl.replyPersonName}}</div>
                          <div class="c2">
                            回复 {{rrl.repliedPersonName}}： {{rrl.content.list[0].content}}
                          </div> 
                          <div class="c3">{{rrl.createTime | formatDatetime('MM-dd hh:mm')}}
                          </div>
                          <div class="c4" v-if="rrl.teacherLike"><div class="praise-btn">老师赞过</div></div>
                        </div>
                        <div class="right-inner-r">
                          <img class="imgs" :src="`https://cdn01.xiaogj.com/uploads/x3/assets/weapp-ai-growth-img/parent/${rrl.myselfLike?'icon/0028':'icon/0026'}.png`"/>
                          <div v-if="rrl.likeQuantity" class="num" :class="{'red':rrl.myselfLike}">{{rrl.likeQuantity}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div class="comment-more-btn" v-if="rc.replyRecordPageNum < rc.replyRecordTotalPage" @click="replyRecordLoadHandle(rc,rcidx)">{{rc.replyRecordPageNum == 0?'展开 '+rc.remainReplyNum+' 条回复':'展开更多回复'}}</div>
              </div>
            </div>
          </template>
          <van-empty
            v-else
            image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
            image-size="128"
            style="padding: 16px 0"
            description="暂无评论～"
          >
          </van-empty>
        </div>
      </div>
    </vx-list>
  </div>
</template>

<script>
export default {
  name: "czl-comment-preview",
  data() {
    return {
      defaultImg: 'https://cdn01.xiaogj.com/uploads/x3/assets/weapp-ai-growth-img/parent/defaultAvatar.png',
      growthRecordId: "",
      companyId: "",
      detail: {},
      materialList: [],
      replyCommentList: [],
      commentQuantity: 0,
      isDeleted: false,
      api: this.$api.replyCommentList,
      replyCommentParams: {
        businessId: this.$route.params.id,
        businessType: 5,  // 业务类型 1素材 2课堂点评 3老师 4评论回复 5成长记录
      },
      height: 200,
    }
  },
  methods: {
    onload(list, res) {
      if (res.page.pageNum <= 1) {
        this.replyCommentList = []
      }
      res.data.forEach(ele => {
        ele.relationStr = ele.studentParentRelation.map(c => (c.studentName || '') + '的' + (c.relation || '')).join('、');
        ele.replyRecordPageNum = 0; // 构建一个分页对象
        ele.replyRecordTotalPage = ele.remainReplyNum ? 1 : 0; // 构建一个分页对象
        ele.replyRecordList = ele.firstReplyRecord ? [ele.firstReplyRecord] : [];
        ele.excludeReplyRecordIds = ele.firstReplyRecord ? [ele.firstReplyRecord.id] : [];
      });
      let newList = this.replyCommentList.concat(res.data);
      this.replyCommentList = newList;
      this.commentQuantity = res.page.totalCount;
    },
    async replyRecordLoadHandle(item,index) { // 加载更多回复
      if (item.replyRecordPageNum < item.replyRecordTotalPage) {
        let pageNum = item.replyRecordPageNum + 1;
        let res = await this.$api.commentReplyList({
          businessId: this.$route.params.id,
          businessType: 5, // 业务类型 1素材 2课堂点评 3老师 4评论回复 5成长记录
          commentRecordId: item.id,
          excludeReplyRecordIds: item.excludeReplyRecordIds,
          page: {
            pageNum: pageNum,
            pageSize: 10
          }
        })

        let _replyCommList = app.tool.clone(this.replyCommentList);
        _replyCommList[index].replyRecordList = _replyCommList[index].replyRecordList.concat(res.data);
        _replyCommList[index].replyRecordPageNum = res.page.pageNum;
        _replyCommList[index].replyRecordTotalPage = res.page.totalPage;
        this.replyCommentList = _replyCommList;
      }
    },
    render() {
      this.showLoading();
      this.$api.growthRecordDetail({
          growthRecordId: this.growthRecordId,
          companyId: this.companyId,
        })
        .then(res => {
          this.$toast.clear();
          if (res.code === 200) {
            this.detail = res.data;
            this.initByStudent(0);
            this.getHeight();
          } else if (res.code == 830000404) {
            this.isDeleted = true;
          } else {
            this.$toast.fail(res.msg);
          }
        });
    },
    initByStudent(index = 0) {
      if (this.detail.studentList.length == 0) {
        return;
      }
      let stuId = this.detail.studentList[index].studentId,
        data = app.tool.clone(this.detail),
        temp = [],
        temp1 = [];

      if (data.materialList) {
        data.materialList.forEach(ml => {
          let stuIds = ml.albumList.map(v => v.studentId);
          if (stuIds.indexOf(stuId) >= 0) {
            temp.push(app.tool.clone(ml));
          } else {
            temp1.push(app.tool.clone(ml));
          }
        })
      }
      if (data.studentList) {
        data.studentList.forEach((sl, sidx) => {
          if (sidx == index) {
            sl.active = true;
          } else {
            sl.active = false;
          }
        })
      }
      this.materialList = temp.concat(temp1);
      this.detail = data;
      if(this.$refs.swipe) {
        this.$refs.swipe.active = 0;
      }
    },
    imgChange(e) {
      let idx = e,
        stuIds = this.materialList[idx].albumList.map(v => v.studentId),
        data = app.tool.clone(this.detail);
      if (stuIds.length > 0) {
        data.studentList.forEach((sl, sidx) => {
          if (stuIds.indexOf(sl.studentId) >= 0) {
            sl.active = true;
          } else {
            sl.active = false;
          }
        })
      } else {
        data.studentList.forEach((sl, sidx) => {
          sl.active = false;
        })
      }
      this.detail = data;
    },
    getHeight(e) {
      var width = window.innerWidth;
      this.materialList.forEach(v=> {
        //获取可使用窗口宽度
        var imgheight = v.height;
        //获取图片实际高度
        var imgwidth = v.width;
        //获取图片实际宽度
        var h = width * (imgheight / imgwidth);
        console.log('图片高度：', h);
        if (h > this.height) {
          this.height = h < 400 ? h : 400
        }
      })
    },
    prewImage(item) {
      const urls = this.materialList.filter(item => item.materialType == 0).map(item => item.originUrl);
      const index = urls.findIndex(url => url == item.originUrl);
      vant.ImagePreview({
        startPosition: index,
        images: urls,
      });
    },
  },
  created() {
    console.log(this.$route.params)
    this.growthRecordId = this.$route.params.id;
    this.companyId = this.$route.params.cid;

    this.render();
  },
}
</script>

<style lang="scss" scoped>
.detail {
  font-size:var(--fs-md);
  line-height:var(--lh-md);
  color: #303133;
  .nav {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background-color: #fff7e8;
    .nav-item {
      flex: 1;
      height: 44px;
      line-height: 44px;
      font-size: 14px;
      img {
        margin-right: 4px;
        width: 20px;
        height: 20px;
      }
    }
  }
  .detail-scroll {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 54px;
    background-color: #f5f7fa;
    .detail-scroll-inner {
      // padding-bottom: 20px;
      background-color: #fff;
    }
    .title {
      padding: 16px 16px 4px 16px;
      font-size: 18px;
      color: #000;
      font-weight: bold;
    }
    // .tags {
    //   display: flex;
    //   padding: 0 16px;
    //   color: #909399;
    //   font-size: 12px;
    //   line-height: 14px;
    // }
    .stu-box {
      overflow-x: auto;
      padding: 12px 16px 0 16px;
      .stu-nav {
        display: flex;
        .stu-item {
          flex-shrink: 0;
          padding: 4px 6px 4px 4px;
          margin-right: 8px;
          color: #303133;
          border-radius: 5px;
          font-size: 14px;
          line-height: 20px;
          font-weight: bold;
          background-color: #f5f7fa;
          display: flex;
          align-items: center;
          min-width: 55px;
          justify-content: center;
          box-sizing: border-box;
          .is-img {
            display: inline-block;
            margin-right: 4px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            min-height: 20px;
          }
          &.active {
            background-color: #F0EEFD;
            border: 1px solid rgba(104,82,235,0.7);
            color: #6852EB;
          }
        }
      }
    }
    .comment-swiper {
      margin-top: 12px;
      swiper-item {
        background-color: #fff;
      }
      .comment-banner-img {
        position: absolute;
        width: 100%;
        height: 100%;
        &.bg {
          position: absolute;
          filter: blur(40px);
          width: 104%;
          height: 104%;
          left: -2%;
          top: -2%;
          bottom: 2%;
          right: 2%;
        }
        .video-class {
          width: 100%;
          height: 100%;
          top: 0;
        }
      }
      .applaud-box {
        position: absolute;
        right: 18px;
        bottom: 16px;
        span-align: center;
        .applaud-icon-wrap {
          display: inline-block;
          padding: 8px 10px 10px 10px;
          border-radius: 50%;
          background-color: rgba(0, 0, 0, 0.2);
          .applaud-icon {
            width: 24px;
            height: 26px;
            transition: all 1s;
          }
        }
        .applaud-num {
          margin-top: 3px;
          color: #fff;
          font-size: 12px;
          line-height: 17px;
          font-weight: bold;
          height: 17px;
        }
      }
    }
    .stu-comment {
      padding: 0 16px;
      // .t1 {
      //   margin: 20px 0 8px 0;
      //   font-size: 18px;
      //   font-weight: bold;
      // }
      .t2 {
        // padding: 20px 0 16px 0;
        padding-top: 16px;
        font-size: 16px;
        line-height: 1.4;
        word-break: break-all;
        display: inline-block;
      }
    }
    .publish-time-box {
      margin-top: 16px;
      padding: 0 16px;
      color: #c0c4cc;
      font-size: 12px;
      line-height: 14px;
    }
    .publish-box {
      margin: 16px 16px 0 16px;
      padding: 0 16px;
      background-color: #f5f7fa;
      border-radius: 8px;
      .publish-inner1 {
        padding: 20px 0 16px 0;
        display: flex;
        .left {
          width: 44px;
          height: 44px;
          border-radius: 100%;
        }
        .center {
          flex: 1;
          margin: 0 40px 0 12px;
          color: #909399;
          font-size: 12px;
          line-height: 14px;
          .t1 {
            margin-bottom: 4px;
            font-size: 16px;
            color: #303133;
            display: flex;
            align-items: center;
            .cname {
              margin-left: 4px;
              font-size: 12px;
              color: #606266;
            }
          }
        }
        .right {
          position: relative;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          color: #606266;
          .img {
            width: 20px;
            height: 20px;
            margin-bottom: 4px;
          }
          .num {
            font-size: 10px;
            line-height: 14px;
            height: 14px;
            &.red {
              color: #f93a4a;
            }
          }
        }
      }
      .publish-inner2 {
        display: flex;
        .left {
          flex: 1;
          font-size: 14px;
          color: #606266;
          height: 44px;
          position: relative;
          .img {
            margin-right: 4px;
            width: 16px;
            height: 16px;
          }
        }
      }
      .publish-inner3 {
        color: #303133;
        font-size: 16px;
        line-height: 22px;
        padding: 16px 0 2px 0;
        font-weight: bold;
      }
      .publish-inner4 {
        color: #909399;
        font-size: 14px;
        line-height: 20px;
        padding: 2px 0 16px 0;
      }
    }
    .comment-box {
      padding: 0 16px;
      margin-top: 12px;
      background-color: #fff;
      .comment-total {
        color: #909399;
        font-size: 14px;
        line-height: 20px;
        padding: 16px 0 0 0;
      }
      .comment-item {
        display: flex;
        &.mt {
          margin-top: 16px;
        }
        .comment-item-left {
          flex-shrink: 0;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          margin-right: 12px;
        }
        .comment-item-right {
          flex: 1;
          &.pd {
            padding-bottom: 12px;
          }
          .comment-item-right-inner {
            display: flex;
            .right-inner {
              position: relative;
              flex: 1;
              .c1 {
                // display: flex;
                // align-items: center;
                color: #909399;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 2px;
                .c1-tag {
                  margin-left: 4px;
                  font-size: 12px;
                  line-height: 17px;
                }
              }
              .c2 {
                display: flex;
                flex-wrap: wrap;
                word-break: break-all;
                color: #303133;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 4px;
                .c2-tips {
                  display: inline-block;
                }
                .rp-name {
                  display: inline;
                  color: #909399;
                }
              }
              .c3 {
                color: #c9cdd4;
                font-size: 12px;
                line-height: 17px;
                position: relative;
                .reply-btn {
                  margin-left: 12px;
                  color: #909399;
                }
              }
              .c4 {
                margin-top: 8px;
                .praise-btn {
                  display: inline-block;
                  padding: 2px 4px;
                  margin-right: 4px;
                  border-radius: 9px;
                  background-color: #f5f7fa;
                  color: #909399;
                  font-size: 10px;
                  line-height: 14px;
                }
              }
            }
            .right-inner-r {
              position: relative;
              margin-left: 10px;
              text-align: center;
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 40px;
              flex-shrink: 0;
              color: #606266;
              .imgs {
                width: 20px;
                height: 20px;
                margin-bottom: 4px;
              }
              .num {
                font-size: 10px;
                line-height: 14px;
                height: 14px;
                &.red {
                  color: #f93a4a;
                }
              }
            }
          }
        }
      }
      .comment-more-btn {
        font-size: 14px;
        line-height: 20px;
        padding: 8px 0 0 48px;
        color: #4e5969;
      }
    }
  }
}
</style>